import Crud from '../views/User/Crud'
import Entity from '../views/User/Add'

let routes = {
    path: '/users',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/users/add',
            name: 'NewUser',
            component: Entity,
            meta: {
                pageTitle: 'Adicionar Usuário',
                breadcrumb: [
                    {
                        text: 'Usuários',
                        active: false,
                        to: '/users',
                    },
                    {
                        text: 'criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/users/edit/:id?',
            name: 'EditUser',
            component: Entity,
            meta: {
                pageTitle: 'Editar Usuário',
                breadcrumb: [
                    {
                        text: 'Usuários',
                        active: false,
                        to: '/users',
                    },
                    {
                        text: 'editar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/users',
            name: 'list-users',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Usuários',
                breadcrumb: [
                    {
                        text: 'Usuários',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
